import { useLocation } from 'js/lib/useRouter';

export const useIsCourseraPlusPromoPage = () => {
  const { pathname } = useLocation();

  return pathname.includes('courseraplus/special');
};
